<template>
  <div v-if="state.buildFinished" class="breadcrumb-wrapper">
    <router-link
      :to="{
        name: 'home',
      }"
      class="breadcrumb-root"
    />
    <template v-for="route in routesArray" :key="route.name">
      <div class="breadcrumb-separator" />
      <router-link :to="route" class="breadcrumb-item">{{
        route.meta.title
      }}</router-link>
    </template>
    <div class="breadcrumb-separator" />
    <div class="breadcrumb-item current" v-text="current_item" />
  </div>
</template>

<script setup>
import { reactive, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useSpaceStore } from "@/stores/space.js";
import { useCampaignStore } from "@/stores/campaign.js";
import { useOnboardingStore } from "@/stores/onboarding.js";
import { get } from "lodash";

const store = {
  space: useSpaceStore(),
  campaign: useCampaignStore(),
  onboarding: useOnboardingStore(),
};

const router = useRouter();
const route = useRoute();

const state = reactive({
  buildFinished: false,
});

const current_item = computed(() => {
  if (route.meta.customTitle) {
    return (
      get(store[route.meta.customTitle.store], route.meta.customTitle.data) ||
      route.meta.customTitle.fallback
    );
  } else {
    return route.meta.title;
  }
});

function buildRoutesTree(route, array) {
  if (route.meta.parent) {
    const currentParams = route.params;
    const parentRoute = router.resolve({
      name: route.meta.parent.name,
      params: currentParams,
    });

    array.unshift(parentRoute);

    buildRoutesTree(parentRoute, array);
  }

  return array;
}

const routesArray = buildRoutesTree(route, []);

onMounted(() => {
  routesArray.forEach((route) => {
    if (route.meta.customTitle) {
      route.meta.title =
        get(store[route.meta.customTitle.store], route.meta.customTitle.data) ||
        route.meta.customTitle.fallback;
    }
  });

  state.buildFinished = true;
});
</script>
